export default __webpack_public_path__ + "static/media/815.a1c305b6.png";